import axios from 'axios'

import { COUNTRY_HEADER, countryPath, getCountryCode } from '@/utils/country'

// Authenticated API client
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { [COUNTRY_HEADER]: getCountryCode() }
})

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('accessToken')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('user')
      localStorage.removeItem('permissions')
      window.location.href = countryPath('/en/login')
    }

    return Promise.reject(error)
  }
)

export default apiClient

// Public API client (no auth interceptor) — use for login and other public endpoints
export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { [COUNTRY_HEADER]: getCountryCode() }
})

publicApi.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message)

    return Promise.reject(error)
  }
)
